
import Typography from '@mui/material/Typography';


export const TextDrugFluvastatin = () => {

return(
<div>
    
<Typography variant="h6" >
<br />

Allopurinol is used to treat gout (a type of arthritis in which uric acid, a naturally occurring substance in the body, 
builds up in the joints and causes sudden attacks of redness, swelling, pain, and heat in one or more joints). 
Allopurinol is also used to treat high levels of uric acid that builds up in the blood as tumors break down in people with certain types of cancer 
who are being treated with chemotherapy medications. It is also used to treat kidney stones that have come back in people 
who have high levels of uric acid in their urine. Allopurinol is in a class of medications called xanthine oxidase inhibitors. 
It works by reducing the production of uric acid in the body. High levels of uric acid may cause gout attacks or kidney stones. 
Allopurinol is used to prevent gout attacks, not to treat them once they occur.


<br /><br />
The FDA-approved label for allopurinol (ALOPRIM) states that patients who carry the HLA-B*58:01 allele, 
found at a higher frequency in individuals of African, Asian 
(e.g., Han Chinese, Korean, Thai), and Native Hawaiian/Pacific Islander ancestry, are at a higher risk of allopurinol hypersensitivity syndrome (AHS). 
The label recommends testing for HLA-B*58:01 in genetically at-risk populations and states that ALOPRIM is not recommended in HLA-B*58-01 positive patients 
unless the benefits outweigh the risks.
<br /><br />


Sources: <br /><br />
https://www.pharmgkb.org/labelAnnotation/PA166234701<br />
https://medlineplus.gov/druginfo/meds/a682673.html

</Typography>

</div>

)
}